import { render } from "./circle.vue?vue&type=template&id=0d5fd79a"
import script from "./circle.vue?vue&type=script&lang=js"
export * from "./circle.vue?vue&type=script&lang=js"

import "./circle.vue?vue&type=style&index=0&id=0d5fd79a&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-snapshot-search/standard/components/market-report/circle.vue'],['render',render],['__file',"circle.vue"]])

export default __exports__